var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"termsPopup__content"},[_c('div',{staticClass:"modal_titleForm termsPopup__title"},[_vm._v(_vm._s(_vm.$t('qic_payment_terms_title')))]),_c('div',{staticClass:"termsPopup__text"},[_vm._v(_vm._s(_vm.$t('qic_payment_terms_conditions')))])])
}
var staticRenderFns = []

export { render, staticRenderFns }